import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';

const GetRuleValues = (EntityAndPropertyName:string):{ values: ILabelValuePair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelValuePair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelValuePair[], AxiosError>(
    EntityAndPropertyName
      ? `/policy/GetRecordValues?entityName_PropertyName=${EntityAndPropertyName}`
      : null,
    (url) => fetcher(url),
  );

  return {
    values: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetRuleValues;
